
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.292 9.29196C20.3849 9.19883 20.4953 9.12494 20.6168 9.07453C20.7382 9.02412 20.8685 8.99817 21 8.99817C21.1316 8.99817 21.2618 9.02412 21.3833 9.07453C21.5048 9.12494 21.6151 9.19883 21.708 9.29196L27.708 15.292C27.8011 15.3848 27.875 15.4952 27.9254 15.6167C27.9759 15.7382 28.0018 15.8684 28.0018 16C28.0018 16.1315 27.9759 16.2617 27.9254 16.3832C27.875 16.5047 27.8011 16.6151 27.708 16.708L21.708 22.708C21.5202 22.8957 21.2656 23.0012 21 23.0012C20.7345 23.0012 20.4798 22.8957 20.292 22.708C20.1042 22.5202 19.9988 22.2655 19.9988 22C19.9988 21.7344 20.1042 21.4797 20.292 21.292L25.586 16L20.292 10.708C20.1989 10.6151 20.125 10.5047 20.0746 10.3832C20.0242 10.2617 19.9982 10.1315 19.9982 9.99996C19.9982 9.86842 20.0242 9.73818 20.0746 9.61669C20.125 9.4952 20.1989 9.38485 20.292 9.29196Z","fill":"#fd5105"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 16C4 15.7348 4.10536 15.4804 4.29289 15.2929C4.48043 15.1054 4.73478 15 5 15H26C26.2652 15 26.5196 15.1054 26.7071 15.2929C26.8946 15.4804 27 15.7348 27 16C27 16.2652 26.8946 16.5196 26.7071 16.7071C26.5196 16.8946 26.2652 17 26 17H5C4.73478 17 4.48043 16.8946 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16Z","fill":"#fd5105"}})])
          )
        }
      }
    